module.exports = __webpack_public_path__ + "static/media/adela_header_3.119aedf6.mp4";